"use client";

import { AppRouterCacheProvider } from "@mui/material-nextjs/v13-appRouter";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ReactNode } from "react";

const theme = createTheme({
  typography: {
    fontFamily: `"Montserrat", sans-serif`, // Font mặc định cho toàn bộ typography
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          fontFamily: `"Montserrat", sans-serif !important`, // Áp dụng toàn bộ trang
        },
        "html, body": {
          fontFamily: `"Montserrat", sans-serif !important`,
        },
        "a, button, input, textarea, select": {
          fontFamily: `"Montserrat", sans-serif !important`,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: `"Montserrat", sans-serif !important`,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: `"Montserrat", sans-serif !important`,
          boxShadow: "none",
          textTransform: "none", // Giữ nguyên kiểu chữ không viết hoa
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: `"Montserrat", sans-serif !important`,
        },
        input: {
          fontFamily: `"Montserrat", sans-serif !important`,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "& img": {
            borderRadius: "4px",
          },
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        enterTouchDelay: 0,
      },
    },
  },
});

export default function ThemeRegistry({ children }: { children: ReactNode }) {
  return (
    <AppRouterCacheProvider options={{ enableCssLayer: true, speedy: true }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </AppRouterCacheProvider>
  );
}
